/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * logicomix-api
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  CompilationApiDTO,
  CompilationBodyApiDTO
} from './Api.schemas'
import { customInstance } from '../AxiosInstance';
import type { ErrorType } from '../AxiosInstance';




export const patchApiCompilationsCompilationId = (
    compilationId: string,
    compilationBodyApiDTO: CompilationBodyApiDTO,
 ) => {
      
      
      return customInstance<CompilationApiDTO>(
      {url: `/api/compilations/${compilationId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: compilationBodyApiDTO
    },
      );
    }
  


export const getPatchApiCompilationsCompilationIdMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiCompilationsCompilationId>>, TError,{compilationId: string;data: CompilationBodyApiDTO}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchApiCompilationsCompilationId>>, TError,{compilationId: string;data: CompilationBodyApiDTO}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchApiCompilationsCompilationId>>, {compilationId: string;data: CompilationBodyApiDTO}> = (props) => {
          const {compilationId,data} = props ?? {};

          return  patchApiCompilationsCompilationId(compilationId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchApiCompilationsCompilationIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchApiCompilationsCompilationId>>>
    export type PatchApiCompilationsCompilationIdMutationBody = CompilationBodyApiDTO
    export type PatchApiCompilationsCompilationIdMutationError = ErrorType<unknown>

    export const usePatchApiCompilationsCompilationId = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiCompilationsCompilationId>>, TError,{compilationId: string;data: CompilationBodyApiDTO}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof patchApiCompilationsCompilationId>>,
        TError,
        {compilationId: string;data: CompilationBodyApiDTO},
        TContext
      > => {

      const mutationOptions = getPatchApiCompilationsCompilationIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const getApiCompilationsCompilationId = (
    compilationId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<CompilationApiDTO>(
      {url: `/api/compilations/${compilationId}`, method: 'GET', signal
    },
      );
    }
  

export const getGetApiCompilationsCompilationIdQueryKey = (compilationId: string,) => {
    return [`/api/compilations/${compilationId}`] as const;
    }

    
export const getGetApiCompilationsCompilationIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompilationsCompilationId>>, TError = ErrorType<unknown>>(compilationId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCompilationsCompilationId>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompilationsCompilationIdQueryKey(compilationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompilationsCompilationId>>> = ({ signal }) => getApiCompilationsCompilationId(compilationId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(compilationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompilationsCompilationId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiCompilationsCompilationIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompilationsCompilationId>>>
export type GetApiCompilationsCompilationIdQueryError = ErrorType<unknown>

export const useGetApiCompilationsCompilationId = <TData = Awaited<ReturnType<typeof getApiCompilationsCompilationId>>, TError = ErrorType<unknown>>(
 compilationId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiCompilationsCompilationId>>, TError, TData>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetApiCompilationsCompilationIdQueryOptions(compilationId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const deleteApiCompilationsCompilationId = (
    compilationId: string,
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/compilations/${compilationId}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteApiCompilationsCompilationIdMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiCompilationsCompilationId>>, TError,{compilationId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiCompilationsCompilationId>>, TError,{compilationId: string}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiCompilationsCompilationId>>, {compilationId: string}> = (props) => {
          const {compilationId} = props ?? {};

          return  deleteApiCompilationsCompilationId(compilationId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiCompilationsCompilationIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiCompilationsCompilationId>>>
    
    export type DeleteApiCompilationsCompilationIdMutationError = ErrorType<unknown>

    export const useDeleteApiCompilationsCompilationId = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiCompilationsCompilationId>>, TError,{compilationId: string}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiCompilationsCompilationId>>,
        TError,
        {compilationId: string},
        TContext
      > => {

      const mutationOptions = getDeleteApiCompilationsCompilationIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const postApiCompilations = (
    compilationBodyApiDTO: CompilationBodyApiDTO,
 ) => {
      
      
      return customInstance<CompilationApiDTO>(
      {url: `/api/compilations`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: compilationBodyApiDTO
    },
      );
    }
  


export const getPostApiCompilationsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompilations>>, TError,{data: CompilationBodyApiDTO}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiCompilations>>, TError,{data: CompilationBodyApiDTO}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCompilations>>, {data: CompilationBodyApiDTO}> = (props) => {
          const {data} = props ?? {};

          return  postApiCompilations(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiCompilationsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCompilations>>>
    export type PostApiCompilationsMutationBody = CompilationBodyApiDTO
    export type PostApiCompilationsMutationError = ErrorType<unknown>

    export const usePostApiCompilations = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompilations>>, TError,{data: CompilationBodyApiDTO}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof postApiCompilations>>,
        TError,
        {data: CompilationBodyApiDTO},
        TContext
      > => {

      const mutationOptions = getPostApiCompilationsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    